import { MaintenanceBanner } from '@/components/MaintenanceBanner'
import { Banner } from '@/components/ui/banner'
import { NotificationsOffer } from '@/components/ui/NotificationsPrompt'
import { MaintenanceState } from '@/models/maintenance'
import { Demo, DsSection } from '../primitives'

export function BannersSection() {
  return (
    <DsSection id="banners" title="Banners" marketing>
      <Demo label="Error · red" className="flex flex-col gap-3">
        <Banner variant="error">
          <strong>Service disruption</strong> Monitoring is degraded in us-east. Updates every 15 minutes.
        </Banner>
        <Banner variant="error" small>
          Small — we couldn&apos;t verify your DOT number.
        </Banner>
      </Demo>
      <Demo label="Warning · amber" className="flex flex-col gap-3">
        <Banner variant="warning">
          <strong>Scheduled maintenance</strong> Evidence export offline Sat 02:00–04:00 UTC.
        </Banner>
        <Banner variant="warning" small>
          Small — your claim will be held until photos are received.
        </Banner>
      </Demo>
      <Demo label="Info · announcement green" className="flex flex-col gap-3">
        <Banner variant="info" onDismiss={() => undefined}>
          Cai now supports SOC 2 evidence export.
        </Banner>
        <Banner variant="info" small>
          Small — showing all active vehicles.
        </Banner>
      </Demo>
      {/* NotificationsPrompt shows this until the browser has asked, and remembers a dismissal. */}
      <Demo label="Desktop notifications offer">
        <NotificationsOffer onTurnOn={() => undefined} onDismiss={() => undefined}>
          Get notified when new quotes land
        </NotificationsOffer>
      </Demo>
      {/* Full-width banners bleed to the viewport edge. The negative margins
          cancel the section's own padding so the demo reads edge-to-edge. */}
      <Demo label="Full width · above nav" className="-mx-8 flex flex-col gap-3 md:-mx-12">
        <Banner variant="black" fullWidth>
          <strong>Scheduled maintenance</strong> Evidence export offline Sat 02:00–04:00 UTC.
        </Banner>
        <Banner variant="green" fullWidth onDismiss={() => undefined}>
          Cai now supports SOC 2 evidence export.
        </Banner>
        <Banner variant="neutral" fullWidth>
          <strong>Showing sandbox data.</strong> Switch to your live org to see real policies.
        </Banner>
      </Demo>
      {/* Two states of the maintenance banner, both full-width above-nav bars.
          Copy comes from the MAINTENANCE_BANNER_* switch notes in the admin. */}
      <Demo label="Maintenance · upcoming" className="-mx-8 md:-mx-12">
        <MaintenanceBanner
          state={MaintenanceState.Upcoming}
          message="Scheduled maintenance Sat 2:00–4:00 AM PT. Cai may be briefly unavailable."
          onDismiss={() => undefined}
        />
      </Demo>
      <Demo label="Maintenance · in progress" className="-mx-8 md:-mx-12">
        <MaintenanceBanner
          state={MaintenanceState.InProgress}
          message="Maintenance in progress — back by 6:00 AM PT. Some features may be unavailable."
        />
      </Demo>
    </DsSection>
  )
}
